import React from "react";
import ReactTable from "react-table";
import { ReporteAsesorMockUp } from "./ReporteAsesor.types";

interface Props {
  data: ReporteAsesorMockUp[];
  onExport: () => void;
}

export const ReporteAsesorTable: React.FC<Props> = ({ data, onExport }) => {
  const columns = [
    {
      Header: "Club",
      accessor: "club"
    },
    {
      Header: "Membresía",
      accessor: "membresia"
    },
    {
      Header: "Tipo Membresía",
      accessor: "tipoMembresia"
    },
    {
      Header: "Evaluación",
      accessor: "evaluacion"
    },
    {
      Header: "Tipo Venta",
      accessor: "tipoVenta"
    },
    {
      Header: "Descripción",
      accessor: "descripcion"
    }
  ];

  return (
    <div>
      <div className="d-flex justify-content-between mb-3">
        <h5>48 registros</h5>
        <button className="btn btn-primary" onClick={onExport}>
          Exportar
        </button>
      </div>
      <ReactTable
        data={data}
        columns={columns}
        sortable={false}
        resizable={false}
        showPagination={false}
        defaultPageSize={10}
        className="-striped -highlight"
        previousText="Anterior"
        nextText="Siguiente"
        loadingText="Cargando..."
        noDataText="No hay registros"
        pageText="Página"
        ofText="de"
        rowsText="filas"
      />
    </div>
  );
};
